<template>
    <div>
      <div class="tab-box">
        <el-radio-group v-model="activeTab" size="small" @change="refresh">
          <el-radio-button label="goods">商品列表</el-radio-button>
          <el-radio-button label="task">任务列表</el-radio-button>
        </el-radio-group>
      </div>
      <div v-if="activeTab === 'goods'">
          <el-form inline size="small">
              <el-form-item label="商品分组">
                  <el-select v-model="searchParams.group_id" filterable clearable placeholder="全部"
                      @change="changeGroupId">
                      <el-option v-for="group in groupList" :key="group.id" :label="group.name"
                          :value="group.id"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="商品子分组">
                  <el-select v-model="searchParams.child_group_id" filterable clearable placeholder="全部">
                      <el-option v-for="group in child_groupList" :key="group.id" :label="group.name"
                          :value="group.id"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item :label="targetDirectionName+'状态'" v-if="targetDirection">
                  <el-select v-model="searchParams[statusKey]" filterable clearable placeholder="全部">
                      <el-option v-for="item in imageWays" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="SKU替换状态">
                  <el-select v-model="searchParams.sku_status" clearable placeholder="全部">
                      <el-option v-for="item in skuWays" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
                  <el-button size="small" @click="refresh">重置</el-button>
              </el-form-item>
          </el-form>
          <div style="margin-bottom: 15px;">
              <el-button plain size="small" @click="handleCheck">AI生成{{targetDirectionName}}</el-button>
          </div>
          <el-table :key="activeTab" v-loading="loading" :data="tableData" show-overflow-tooltip="false" max-height="800px"
              :header-cell-style="headerCellStyle" row-key="id" @selection-change="handleSelectionChange">
              <el-table-column type="selection" align="center" min-width="30" max-width="80"
                  :selectable="checkSelectable"></el-table-column>
              <el-table-column label="上新时间" prop="created_at_text" align="center" width="150"></el-table-column>
              <el-table-column label="商品来源" prop="source_web" align="center" width="150">
                  <template slot-scope="scope">
                    <span class="source-tag" :style="`background:${sourceMap?.[scope.row.source_web]?.color??'#fff'};`">
                        {{sourceMap?.[scope.row.source_web]?.label??'未知'}}
                      </span>
                  </template>
              </el-table-column>
              <el-table-column label="分组" prop="group_name" align="center" width="200">
                  <template #default="{ row }">
                      <el-tooltip :content="formatGroupName(row)" placement="top" :open-delay="300"
                          popper-class="group-tip">
                          <span class="group-name-cell">{{ formatGroupName(row) }}</span>
                      </el-tooltip>
                  </template>
              </el-table-column>
              <el-table-column label="商品信息" min-width="150" max-width="250">
                  <template slot-scope="scope">
                      <div class="goods_wrap">
                          <div class="img_box">
                              <img class="coverimg" :src="scope.row.main_image" alt="商品图" />
                          </div>
                          <div class="con_box">
                              <p class="info-item blue"> {{ scope.row.source_product_id }} </p>
                              <p class="info-item blue"> {{ scope.row.title }} </p>
                          </div>
                      </div>
                  </template>
              </el-table-column>
              <el-table-column :label="targetDirectionName+'状态'" align="center" min-width="60" max-width="380">
                  <template #default="{ row }">
                      <div class="white-bg-status-wrap">
                          <!-- 状态文字标签 -->
                          <span class="status-tag" :class="{
                              tag1: row[statusKey] === 1,
                              tag2: row[statusKey] === 2,
                              tag3: row[statusKey] === 3 && !isImageExpire(row),
                              tagExpire: row[statusKey] === 3 && isImageExpire(row)
                          }">
                              {{ getImageStatusText(row) }}
                          </span>
                          <span v-if="row[statusKey] === 3 && !isImageExpire(row)" class="status-tag tag4"  style="cursor: pointer;"
                                @click="handleViewImg(row)">
                              查看效果
                          </span>
                      </div>
                  </template>
              </el-table-column>
              <el-table-column label="操作" prop="created_at" align="center">
                  <template #default="{ row }">
                      <el-button type="primary" size="mini" @click="handleEdit(row)">编辑商品</el-button>
                  </template>
              </el-table-column>
          </el-table>
      </div>
      <div v-if="activeTab==='task'">
        <el-form inline size="small">
          <el-form-item label="任务编号">
            <el-input v-model="searchParams.task_no" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchParams.status" filterable clearable placeholder="全部" @change="handleSearch">
              <el-option v-for="item in taskStatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="SKU状态">
            <el-select v-model="searchParams.sku_status" filterable clearable placeholder="全部" @change="handleSearch">
              <el-option v-for="item in skuWays" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理方式">
            <el-select v-model="searchParams.process_direction" filterable clearable placeholder="全部" @change="handleSearch">
              <el-option v-for="item in checkWays" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker class="w340"
                  v-model="searchParams.created_at"
                  type="datetimerange"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
            <el-button size="small" @click="refresh">重置</el-button>
          </el-form-item>
        </el-form>
        <el-table :key="activeTab" v-loading="loading" :data="tableData" show-overflow-tooltip="false" max-height="800px"
                  :header-cell-style="headerCellStyle" row-key="id" >
          <el-table-column label="任务编号" prop="task_no" align="center" ></el-table-column>
          <el-table-column label="处理方式" prop="process_direction" align="center" >
            <template #default="{ row }">
              <div>{{checkMap?.[row.process_direction]?.label??''}}</div>
            </template>
          </el-table-column>
          <el-table-column label="生成目标" prop="target_direction" align="center" >
            <template #default="{ row }">
              <div>{{row.target_direction==1?'AI':''}}{{targetDirectionMap[row.target_direction]}}</div>
            </template>
          </el-table-column>
          <el-table-column label="指定主图素材" prop="specify_materials" align="center" >
            <template #default="{ row }">
              <div>{{materialsMap?.[row.specify_materials]?.label??''}}<span style="color: #999;" v-if="[4,5].includes(row.specify_materials)">（如无则默认最后一张）</span></div>
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="created_at" align="center"  >
            <template #default="{ row }">
              <div class="statistics-box">
                <div>商品数：<span>{{row.product_total_count || 0}}</span></div>
                <div>成功数：<span>{{row.product_success_count || 0}}</span></div>
                <div>失败数：<span>{{row.product_failed_count || 0}}</span></div>
                <div>消耗算力：<span>{{row.use_power_num || 0}}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="status_name" align="center">
            <template #default="{ row }">
              <el-tag :type="taskStatusMap[row.status].color" v-if="taskStatusMap[row.status]">{{row.status_name}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="SKU状态" prop="sku_status" align="center">
            <template #default="{ row }">
              <el-tag :type="skuStatusMap[row.sku_status].color" v-if="skuStatusMap[row.sku_status]">{{skuStatusMap[row.sku_status].label}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="时间" prop="created_at" align="center" width="200" >
            <template #default="{ row }">
              <div>创建：{{row.created_at}}</div>
              <div>更新：{{row.updated_at}}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="210">
            <template #default="{ row }">
              <el-button type="primary" size="mini" @click="handleViewTask(row)">查看</el-button>
              <el-button type="primary" plain size="mini" @click="handleCancel(row)" v-if="['1','2','5'].includes(String(row.status))">取消</el-button>
              <el-button type="warning" plain size="mini" @click="handlePause(row)" v-if="['1','2'].includes(String(row.status))">暂停</el-button>
              <el-button type="success" plain size="mini" @click="handleStart(row)" v-if="row.status==5">启动</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" :pageSizes="[10, 20, 50, 100, 200,500,1000]"
                  @pagination="getDataList" layout="total, sizes, prev, pager, next, jumper" v-if="page_data.total > 0" />
      <!-- 生成白底图片 -->
      <el-dialog :title="'生成'+targetDirectionName" :visible.sync="aiFormShow" width="800px">
          <el-form label-width="180px" ref="aiFormRef" :model="aiForm" >
            <el-form-item label="已选商品：" v-if="selectData.length"><span style="color: red">{{selectData.length}}</span>个</el-form-item>
            <template v-if="targetDirection===1">
              <el-form-item label="使用主图：" prop="specify_materials" :rules="[{required: true, message: '请选择使用主图'}]">
                <el-radio-group v-model="aiForm.specify_materials" class="radio-box">
                  <el-radio v-for="item in materialsList" :label="item.value" :key="item.value">{{ item.label }}
                    <span style="color: #f42c2c;" v-if="item.value===9">（推荐）</span>
                    <span style="color: #999;" v-if="item.value===4||item.value===5">（如无则默认最后一张）</span>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="生成模式：" prop="target_direction" :rules="[{required: true, message: '请选择生成模式'}]" style="margin-bottom: 0">
                <el-radio-group v-model="aiForm.target_direction" >
                  <el-radio :label="1">AI白底图</el-radio>
                  <el-radio :label="4">常规白底图</el-radio>
                </el-radio-group>
              </el-form-item>
            </template>
            <el-form-item :style="`margin-bottom:${targetDirection===1?'22px':'4px'}`">
              <div style="color:#ff4545;line-height: 17px">
                <template v-if="targetDirection===1">
                  AI白底图：单张费用 <strong>{{powerFee[5]||''}}</strong> 算力<br/>常规白底图：单张费用 <strong>{{powerFee[10]||''}}</strong> 算力，生成效果不能保证达标率
                </template>
                <template v-if="targetDirection===2">
                  AI3/4图：单商品费用 <strong>{{powerFee[6]||''}}</strong> 算力
                </template>
                <template v-if="targetDirection===3">
                  AI视频：单商品费用 <strong>{{powerFee[7]||''}}</strong> 算力
                </template>
              </div>
            </el-form-item>
            <el-form-item label="需要生成图片商品：" prop="process_direction" :rules="[{required: true, message: '请选择需要生成图片商品'}]">
              <el-select v-model="aiForm.process_direction" placeholder="请选择">
                <el-option v-for="item in checkWays" :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品分组：">
                <el-select v-model="aiForm.group_ids" filterable clearable multiple collapse-tags placeholder="全部"
                    @change="changeGroupIds">
                    <el-option v-for="group in groupList" :key="group.id" :label="group.name"
                        :value="group.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商品子分组：">
                <el-select v-model="aiForm.child_group_ids" filterable clearable multiple collapse-tags
                    placeholder="全部">
                    <el-option v-for="group in child_groupList" :key="group.id" :label="group.name"
                        :value="group.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="SKU替换状态：">
                <el-select v-model="aiForm.sku_status" clearable placeholder="全部">
                    <el-option v-for="item in skuWays" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
          </el-form>
          <template #footer>
              <span style="color: red; text-align: center;">选择商品不要超过1万,使用过程会消耗算力。 </span>
              <el-button @click="aiFormShow = false">取消</el-button>
              <el-button type="primary" @click="checkTaskPower" :loading="submitFormLoading">确定</el-button>
          </template>
      </el-dialog>
      <el-dialog title="所需算力明细" :visible.sync="powerShow" width="400px">
        <div style="display: grid;gap: 10px;">
          <p>当前算力：<strong>{{ powerInfo.current_power_num||0 }}</strong></p>
          <p>预计消耗：<strong>{{ powerInfo.required_power_num||0 }}</strong></p>
          <p>符合条件的商品数：<strong>{{ powerInfo.product_count||0 }}</strong></p>
          <p>是否充足：<el-tag :type="powerInfo.is_sufficient ? 'success' : 'danger'" size="small">{{powerInfo.is_sufficient ? '是' : '否'}}</el-tag></p>
        </div>
        <template #footer>
          <el-button @click="powerShow = false">取消</el-button>
          <el-button type="primary" @click="submitForm" :loading="checkFormLoading">确定生成</el-button>
        </template>
      </el-dialog>
      <!--任务详情弹窗-->
      <el-dialog :title="'任务 - '+detailSearchParams.task_no" :visible.sync="taskDetailShow" width="60%">
        <el-form inline size="small">
          <el-form-item label="商品ID">
            <el-input v-model="detailSearchParams.product_id" placeholder="请输入商品ID" clearable class="w200"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="detailSearchParams.status" placeholder="全部" clearable class="w200">
              <el-option v-for="item in detailStatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker class="w340"
                            v-model="detailSearchParams.created_at"
                            type="datetimerange"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
             >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="handleSearchDetail">查询</el-button>
            <el-button size="small" @click="refreshDetail">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="statistics-box">
          商品数：<span>{{detailStatistics.product_count || 0}}</span> |
          成功数：<span>{{detailStatistics.success_count || 0}}</span> |
          失败数：<span>{{detailStatistics.failed_count || 0}}</span> |
          使用算力：<span>{{detailStatistics.use_power_num || 0}}</span>
        </div>
        <el-table :data="detailTableData" v-loading="detailLoading" :header-cell-style="headerCellStyle" max-height="700px">
          <el-table-column label="商品ID" prop="product_id"></el-table-column>
          <el-table-column label="商品" align="center" width="100">
            <template #default="{row}">
              <el-image class="coverimg" :src="row.pending_contents[0]" alt="商品图" @click="previewImage(row.pending_contents)"/>
            </template>
          </el-table-column>
          <el-table-column label="成功数" prop="success_count" align="center"></el-table-column>
          <el-table-column label="失败数" prop="failed_count" align="center"></el-table-column>
          <el-table-column label="使用算力" prop="use_power_num" align="center"></el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template #default="{ row }">
                <el-tag :type="detailStatusMap[row.status].color" size="small" v-if="detailStatusMap[row.status]">{{row.status_name}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="created_at" align="center" width="150"></el-table-column>
          <el-table-column label="操作" prop="created_at" align="center">
            <template #default="{ row }">
              <template v-if="row.status == 3">
              <el-button type="primary" plain  size="mini" @click="previewVideo(row.videoUrl,true)" v-if="targetDirection===3">查看效果</el-button>
              <el-button type="primary" plain  size="mini" @click="previewImage(row.processed_contents,true)" v-else>查看效果</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <Pagination :total="detailPageData.total" :page.sync="detailPageData.page" :limit.sync="detailPageData.limit"
                    @pagination="getTaskDetailDataList" layout="total, sizes, prev, pager, next, jumper" v-if="detailPageData.total > 0" />
      </el-dialog>
      <el-dialog :title="isEffectImg?targetDirectionName:'商品图'" :visible.sync="imagesShow" width="600px">
        <div class="img-list">
          <el-image :class="isEffectImg&&targetDirection===2?'img-item-34':'img-item'" v-for="(item, index) in imageUrlList" :key="index" :src="item" :preview-src-list="imageUrlList" alt="商品图" />
        </div>
      </el-dialog>
      <el-dialog title="视频效果" :visible.sync="videoPreviewShow" width="700px" @close="closeVideoPreview">
        <video v-if="videoPreviewShow && videoUrl" ref="previewVideoPlayer" :src="videoUrl" class="preview-video-player" controls autoplay @error="handleVideoError">
          您的浏览器不支持视频播放。
        </video>
      </el-dialog>
      <!-- 在最外层 div 内添加 -->
      <el-image ref="globalImg" style="display: none;" :src="imageUrlList[0]" :preview-src-list="imageUrlList"></el-image>
      <!-- 弹窗组件，传递API、全局提示、同步变量 -->
      <EditDialog :visible.sync="cloudEditShow" :cloud-edit-mode="cloudEditMode" :cloud-edit-list="cloudEditList"
          :cloud-edit-source-list="cloudEditSourceList" />

    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

import Pagination from "@/components/pagination/pagination.vue";
import EditDialog from "../edit/editDialog.vue";

export default {
    props: {
        groupList: {
            type: Array,
            default: function (){
              return []
            }
        },
      targetDirection:{
        type:Number,
        default: 1,//1:'白底图',2:'3/4图片',3:'视频'
      }
    },
    components: {
        Pagination,
        EditDialog,
    },
    data() {
        return {
          headerCellStyle:{ background: '#eef1f6', color: '#606266' },
          isManager: false,
          activeTab: 'goods',
          loading: false,
          tableData: [],
          page_data: {
              limit: 20,
              page: 1,
              total: 0,
          },
          searchParams: {
              status: 1,
              is_image_white_bg: '',
              sku_status: '',
              group_id: [],
              child_group_id: [],
          },
          selectData: [],
          aiFormShow: false,
          aiForm: {group_ids: [],child_group_ids: [],product_ids:[], sku_status: '',process_direction: '',target_direction: 1,target_quantity: '' },
          // checkWays: [ { label: '全部商品', value: 1 },{ label: '未生成白底图', value: 2 },{ label: '已生成白底图', value: 3 }],
          skuWays: [{ label: '未替换', value: 1,color: 'info' }, { label: '已替换', value: 2, color: 'success' }, { label: '找不到', value: 3,color: 'danger' }],
          segWays: [{ label: '商品生成', value: 1 }, { label: '服饰生成', value: 2 }],
          imageWays: [{ label: '未生成', value: 1 }, { label: '生成中', value: 2 }, { label: '已生成', value: 3 }, { label: '已过期', value: 4 }],
          aiWays: [{ label: '正式AI提示词', value: 1 }, { label: '测试AI提示词', value: 2 }],
          statusList: [{ label: '待处理', value: 1 }, { label: '处理中', value: 2 }, { label: '处理完成', value: 3 }, { label: '已取消', value: 4 }, { label: '异常', value: 9 }],
          taskStatusList: [{ label: '待处理', value: 1, color: 'warning' }, { label: '处理中', value: 2, color: 'primary' }, { label: '已完成', value: 3, color: 'success' }, { label: '已取消', value: 4, color: 'info' }, { label: '暂停', value: 5,color: 'info' }, { label: '异常', value: 9, color: 'danger' }],
          targetDirectionMap:{1:'白底图',2:'3/4图片',3:'视频',4:'常规白底图'},
          submitFormLoading: false,
          powerShow: false,
          powerInfo:{},
          checkFormLoading:false,

          child_groupList: [],
          imageUrlList: [], // 当前查看的图片URL
          cloudEditShow: false,
          cloudEditMode: 'single',
          cloudEditList: [],
          cloudEditSourceList: [],

          taskDetailShow:false,
          detailSearchParams:{task_id:'', product_id:'', status:'',created_at:[]},
          detailPageData:{ page:1, limit:20, total:0,},
          detailLoading:false,
          detailTableData:[],
          detailStatusList:[{ label: '待处理', value: 1, color: 'warning' }, { label: '处理中', value: 2, color: 'primary' }, { label: '已完成', value: 3, color: 'success' }, { label: '已取消', value: 4, color: 'info' }, { label: '异常', value: 5, color: 'danger' }],
          detailStatistics:{},

          imagesShow:false,
          isEffectImg:false,
          videoUrl:"",
          videoPreviewShow:false,
          sourceMap:{
            2:{label: '1688', color: '#67c23a'},
            3:{label: 'TB', color: '#e6a23c'},
            4:{label: 'PDD', color: '#f56c6c'},
            5:{label: 'DY', color: '#ff4063'},
            9:{label: '星好货', color: '#409eff'}
          },
          powerFee:{},
          materialsList:[{label: '最后一张', value: 9},{label: '第一张', value: 1}, {label: '第二张', value: 2}, {label: '第三张', value: 3}, {label: '第四张', value: 4}, {label: '第五张', value: 5}],
        }
    },
    computed: {
      ...mapState({
        users: (state) => state.login.userinfo
      }),
      targetDirectionName(){
       return this.targetDirectionMap[this.targetDirection]
      },
      statusKey(){
        const keys=['','is_image_white_bg','is_image_three_to_four','is_video']
        return keys[this.targetDirection]
      },
      checkWays(){
        return [ { label: '全部商品', value: 1 },{ label: '未生成'+this.targetDirectionName, value: 2 },{ label: '已生成'+this.targetDirectionName, value: 3 }]
      },
      taskStatusMap(){
       return this.arrayToObject(this.taskStatusList)
      },
      skuStatusMap(){
        return this.arrayToObject(this.skuWays)
      },
      checkMap(){
        return this.arrayToObject(this.checkWays)
      },
      detailStatusMap(){
        return this.arrayToObject(this.detailStatusList)
      },
      materialsMap(){
        const list = this.materialsList.concat({label: '全部主图', value: 0})
        return this.arrayToObject(list)
      },
   },
    created() {
        this.ismanager = (this.users.mer_user_id === '1' || this.users.mer_user_id === '666')
        // this.$emit('update:is-manager', this.ismanager)
    },

    methods: {
      ...mapActions({
        getCloudProductList: 'ucenter/getCloudProductList',
        opGetAIImgWhiteImg: 'ucenter/opGetAIImgWhiteImg',
        opGetAIImgGenerateTask: 'ucenter/opGetAIImgGenerateTask',
        opCreateAIImgGenerateTask: 'ucenter/opCreateAIImgGenerateTask',
        opCheckAIImgGeneratePower: 'ucenter/opCheckAIImgGeneratePower',
        opGetAIImgGenerateTaskDetail: 'ucenter/opGetAIImgGenerateTaskDetail',
        opPauseAIImgGenerateTask: 'ucenter/opPauseAIImgGenerateTask',
        opStartAIImgGenerateTask: 'ucenter/opStartAIImgGenerateTask',
        opCancelAIImgGenerateTask: 'ucenter/opCancelAIImgGenerateTask',
        opGetAIImgGeneratePowerFees: 'ucenter/opGetAIImgGeneratePowerFees',
      }),
      initData() {
        this.activeTab='goods'
        this.refresh()
        this.getAIImgPowerFee()
      },
      getAIImgPowerFee(){
        this.opGetAIImgGeneratePowerFees({
          data:{},
          success: (res) => {
            if(res.code === 200){
              let feeConfig = {}
              for(let item of res.data){
                feeConfig[item.type] = item.power_num
              }
              this.powerFee=feeConfig
            }

          }
        })
      },
      arrayToObject(list){
          let obj = {}
          for(let item of list){
            obj[item.value] = item
          }
          return obj
      },
      checkSelectable(row) {
          if (row.merchant_id === 0) {
              return this.ismanager === true;
          }
          return true;
      },
      async getDataList() {
          this.tableData = []
          this.loading = true
         const res = this.activeTab==='goods'? await this.getGoodsList(): await this.getTaskList()
         this.loading = false
         if (res.code == 200) {
           this.tableData = res.data.list
           this.page_data.total = res.data.total
         } else {
           this.$message.error(res.message)
         }
      },
      getGoodsList(){
        let params = { page_size: this.page_data.limit, page: this.page_data.page, ...this.searchParams }
          return new Promise((resolve)=>{
              this.getCloudProductList({
                  data: params,
                  success: (res) => {
                    resolve(res)
                  }
              })
          })
      },
      getTaskList(){
        let params = { page_size: this.page_data.limit, page: this.page_data.page, ...this.searchParams }
        return new Promise((resolve)=>{
          this.opGetAIImgGenerateTask({
            data: params,
            success: (res) => {
              resolve(res)
            }
          })
        })
      },
      handleSearch() {
          this.page_data.page = 1
          this.getDataList()
      },
      refresh() {
          this.tableData = []
          this.page_data.page = 1
          this.page_data.total = 0
          this.child_groupList = []
          if(this.activeTab=='goods'){
            this.searchParams = {
              status: 1,
              sku_status: '',
              group_id: [],
              child_group_id: [],
            }
            this.$set(this.searchParams,this.statusKey,'')
          }else {
            this.searchParams = {
              status: '',
              task_no:'',
              target_direction:this.targetDirection,
              process_direction:'',
              sku_status:'',
              created_at:[]
            }
          }
          this.getDataList()
      },
      formatGroupName(row) {
          let group_id = row.group_id
          let group_name = this.groupList.find(i => i.id === group_id)?.name || '-'
          let child_group_id = row.child_group_id || '-'
          const target = this.groupList.find(i => i.id === group_id)?.child_groups?.find(i => i.id === child_group_id)
          const child_group_name = target?.name || null
          if (child_group_name) {
              group_name += '\n' + child_group_name
          }
          return group_name;
      },
      // 获取状态文字
      getImageStatusText(row) {
          const val =row[this.statusKey]
          if (val === 1) return '未生成';
          if (val === 2) return '生成中';
          if (val === 3) {
              // 判断是否过期：生成时间 +90天 < 当前时间
              if (this.isImageExpire(row)) return '已过期';
              return '已生成';
          }
          return '未知';
      },
      // 判断白底图是否过期（image_white_at + 90天\image_three_to_four_at + 90天）
      isImageExpire(row) {
        // const at = this.targetDirection===1?row.image_white_at:this.targetDirection===2?row.image_three_to_four_at:row.video_at
        const atKeys=['','image_white_at', 'image_three_to_four_at','video_at']
        const at = row[atKeys[this.targetDirection]]
          if (!at) return true;
          const createTime = new Date(at);
          // 时间戳 + 90天毫秒数
          const expireTime = createTime.getTime() + 90 * 24 * 60 * 60 * 1000;
          const now = Date.now();
          return expireTime < now;
      },


      // === 生成AI白底图 ===
      handleCheck() {
        this.child_groupList = []
        this.aiFormShow = true
        this.aiForm={
          group_ids: [],
          child_group_ids: [],
          product_ids:[],
          sku_status: '',
          process_direction: '',
          target_direction: this.targetDirection,
          target_quantity: ''
        }
        if(this.targetDirection===1){
          this.$set(this.aiForm, 'specify_materials', 9)
        }
        this.$nextTick(()=>{
          if( this.$refs.aiFormRef){
            this.$refs.aiFormRef.clearValidate()
          }
        })
      },
      //计算所需算力
      checkTaskPower() {
        this.$refs.aiFormRef.validate((vaild)=>{
          if(!vaild) return
          this.submitFormLoading = true
          let params={...this.aiForm}
          if(this.selectData.length){
            params.product_ids = this.selectData.map(item => item.product_id)
          }
          this.opCheckAIImgGeneratePower({
            data: params,
            success: (res) => {
              this.submitFormLoading = false
              if (res.code == 200) {
                this.powerInfo = res.data
                this.powerShow = true
              } else {
                this.$message.error(res.message)
              }
            }
          })
        })
      },
      //创建生成任务
      submitForm() {
        this.checkFormLoading = true
        let params={...this.aiForm}
        if(this.selectData.length){
          params.product_ids = this.selectData.map(item => item.product_id)
        }
        this.opCreateAIImgGenerateTask({
          data: params,
          success: (res) => {
            this.checkFormLoading = false
            if (res.code == 200) {
              this.powerShow=false
              this.aiFormShow = false
              this.$message.success(res.message)
              this.getDataList()
            } else {
              this.$message.error(res.message)
            }
          }
        })
      },
      changeGroupId(val) {
        this.$set(this.searchParams, 'child_group_ids', [])
        this.child_groupList = this.groupList.filter(i => val === i.id).map(i => i.child_groups || []).flat()
      },
      changeGroupIds(val) {
        this.$set(this.aiForm, 'child_group_ids', [])
        this.child_groupList = this.groupList.filter(i => val.includes(i.id)).map(i => i.child_groups || []).flat()
      },
      handleSelectionChange(rows){
        this.selectData = rows
      },

      // 点击查看图片 请求接口
      handleViewImg(row) {
          try {
              this.opGetAIImgWhiteImg({
                  data: { 'product_id': row.product_id, 'type': this.targetDirection },
                  success: (res) => {
                      if (res.code == 200) {
                          // 设置图片URL并显示预览
                          if(res.data && res.data.length > 0 && res.data[0]) {
                            if(this.targetDirection===3){
                              this.previewVideo(res.data)
                            }else{
                              this.previewImage(res.data)
                            }
                          } else {
                              this.$message.error(this.targetDirection===3?'未查询到视频':'未查询到图片')
                          }
                      } else {
                          this.$message.error(res.message)
                      }
                  }
              })
          } catch (err) {
              this.$message.error('图片加载失败');
          }
      },
      // 打开单条编辑
      handleEdit(row) {
          this.cloudEditMode = 'single'
          this.cloudEditList = [row]
          this.cloudEditShow = true
      },
      // 打开批量编辑
      handleCloudBatchEdit() {
          this.cloudEditMode = 'batch'
          this.cloudEditList = [...this.selectData]
          this.cloudEditShow = true
      },
      // 关闭弹窗重置数据
      handleCloudEditClose() {
          this.cloudEditDirty = false
          this.cloudEditMode = 'single'
          this.cloudEditList = []
          this.cloudEditShow = false
      },

      // === 取消任务 ===
      handleCancel(row) {
        this.$confirm(`确定要取消任务【${row.task_no}】吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.opCancelAIImgGenerateTask({
            data: {id: row.id},
            success: (res) => {
              if (res.code == 200) {
                this.$message.success('取消成功')
                this.getDataList()
              } else {
                this.$message.error(res.message)
              }
            }
          })
        })
      },
      // === 启动任务 ===
      handleStart(row) {
        this.$confirm(`确定要启动任务【${row.task_no}】吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.opStartAIImgGenerateTask({
            data: {id: row.id},
            success: (res) => {
              if (res.code == 200) {
                this.$message.success('启动成功')
                this.getDataList()
              } else {
                this.$message.error(res.message)
              }
            }
          })
        })
      },
      // === 暂停任务 ===
      handlePause(row) {
        this.$confirm(`确定要暂停任务【${row.task_no}】吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.opPauseAIImgGenerateTask({
            data: {id: row.id},
            success: (res) => {
              if (res.code == 200) {
                this.$message.success('暂停成功')
                this.getDataList()
              } else {
                this.$message.error(res.message)
              }
            }
          })
        })
      },

      // === 任务明细 ===
      handleViewTask(row) {
        this.detailSearchParams={
          task_id:row.id,
          task_no:row.task_no,
          product_id:'',
          status:'',
          created_at:[]
        }
        this.taskDetailShow = true
        this.refreshDetail()
      },
      refreshDetail(){
        this.detailSearchParams.product_id=''
        this.detailSearchParams.status=''
        this.detailSearchParams.created_at=[]
        this.handleSearchDetail()
      },
      handleSearchDetail() {
        this.detailPageData.page = 1
        this.getTaskDetailDataList()
      },
      getTaskDetailDataList(){
        const params = {page:this.detailPageData.page,page_size:this.detailPageData.limit,...this.detailSearchParams}
        this.detailLoading=true
        this.opGetAIImgGenerateTaskDetail({
            data: params,
            success: (res) => {
              this.detailLoading=false
                if (res.code == 200) {
                    this.detailTableData = res.data.list
                    this.detailPageData.total = res.data.total
                    this.detailStatistics = res.data.statistics||{}
                } else {
                    this.$message.error(res.message)
                }
            }
        })
      },
      previewImage(images,isEffect=false) {
        this.imageUrl = images[0];
        this.imageUrlList = images;
        if(images.length>1){
          this.imagesShow  = true
          this.isEffectImg = isEffect
        }else{
          this.$nextTick(() => {
            const img = this.$refs.globalImg
            if (img && img.clickHandler) {
              img.clickHandler()
            }
          })
        }
      },
      previewVideo(urls){
        if (!urls || (Array.isArray(urls) && urls.length === 0) || (typeof urls === 'string' && !urls.trim())) {
          this.$message.warning('暂无可预览的视频')
          return
        }
        this.videoUrl = Array.isArray(urls) ? urls[0] : urls
        this.videoPreviewShow = true
      },
      handleVideoError(){
        this.$message.error('视频加载失败，请稍后重试')
      },
      closeVideoPreview(){
        const videoPlayer = this.$refs.previewVideoPlayer
        if (videoPlayer) {
          videoPlayer.pause()
        }
        this.videoUrl = ''
      }

    }
}
</script>


<style scoped>
.w200{
  width: 200px;
}
.w340{
  width: 340px;
}
.tab-box {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
}

.statistics-box{
  font-size: 14px;
  color: #999999;
  margin-bottom: 10px;
}
.statistics-box span{
  color: #000;
}
.goods_wrap {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    width: 100% !important;
    box-sizing: border-box !important;
    /* align-items: center; */
}

/* 图片固定大小，不缩放变形 */
.img_box {
    width: 60px;
    height: 60px;
    flex-shrink: 0 !important;
}

.coverimg {
    width: 60px;
    height: 60px ;
    object-fit: cover;
    border-radius: 4px;
}

.preview-video-player {
    display: block;
    width: 100%;
    max-height: 70vh;
    object-fit: contain;
}

/* 内容区域自动适配 */
.con_box {
    flex: 1;
    display: grid;
    gap: 3px;
}

/* 每行信息样式 */
.info-item {
    font-size: 12px;
    line-height: 1.3;
}

/* 标题文字自动换行，不撑破布局 */
.blue {
    color: #0096ff;
}

/* ========== 表格核心：允许内容自动换行 + 不隐藏 ========== */

.source-tag {
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 12px;
    color: #fff;
}

.white-bg-status-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
}

.status-tag {
    margin-left: 1.5px;
    padding: 2px 8px;
    border-radius: 3px;
    font-size: 12px;
    color: #fff;
}

.tag1 {
    background: #409eff;
}

.tag2 {
    background: #67c23a;
}

.tag3 {
    background: #e6a23c;
}

.tagExpire {
    background: #3e3343;
}

.tag4 {
    background: #f56c6c;
}

.group-name-cell {
    white-space: pre-line;
}

.group-tip {
    white-space: pre-line !important;
}

.img-list{
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 20px 0;
}
.img-item{
  width: 100px;
  height: 100px;
  border: 1px solid #eee;
}
.img-item-34{
  width: 75px;
  height: 100px;
  border: 1px solid #eee;
}

.radio-box{
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
}

</style>
